import { useCallback, useState, type CSSProperties } from "react";
import moment from "moment-timezone";
import { Input } from "../../../ui/input";
import { checkTime } from "./checkTimes";

const TIME_FORMAT = "hh:mm A"; // company time format

type CustomTimeInputProps = {
    disabled?: boolean;
    value?: Date | null;
    className?: string;
    style?: CSSProperties;
    placeholder?: string;
    timeFormat?: string;
    onChange?: (value?: Date | null) => void;
};

function CustomTimeInput({
    disabled,
    value,
    className,
    style,
    placeholder,
    timeFormat,
    onChange,
}: CustomTimeInputProps) {
    const format = timeFormat || TIME_FORMAT;
    const [inputValue, setInputValue] = useState<string | null>(null);

    const formattedValue = value ? moment(value).format(format) : "";

    const onValueChange = useCallback(
        (text: string) => {
            setInputValue(null);

            const trimmed = text.replace(/\s/g, "").toLowerCase();
            if (!trimmed) {
                onChange?.(null);
                return;
            }

            const parsed = checkTime(trimmed);
            if (parsed) {
                onChange?.(parsed.toDate());
            }
        },
        [onChange],
    );

    return (
        <Input
            value={inputValue ?? formattedValue}
            placeholder={placeholder || format}
            disabled={disabled}
            className={className}
            style={style}
            maxLength={11}
            onChange={(e) => setInputValue(e.target.value)}
            onBlur={(e) => onValueChange(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    onValueChange(e.currentTarget.value);
                }
            }}
            onFocus={(e) => e.target.select()}
        />
    );
}

export default CustomTimeInput;
